/** Pure display formatters — fixed locale + UTC for snapshot determinism. */

const DATE_OPTS: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'UTC',
};

const DATETIME_OPTS: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZone: 'UTC',
};

export function formatAdminDate(epochMs: number): string {
  return new Date(epochMs).toLocaleDateString('en-US', DATE_OPTS);
}

export function formatAdminDateTime(epochMs: number): string {
  return new Date(epochMs).toLocaleString('en-US', DATETIME_OPTS);
}
